import APICall from "../utils/APICall"

export default class ChequeServices {
    static listConfirmed = async (page, pageLimit, search, from, to) => {
        return await APICall(`/api/Cheque/admin/list-confirmed-cheques?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}`, "GET")
    }
    static listSTop = async (page, pageLimit, search, from, to, blockageStatus) => {
        return await APICall(`/api/Cheque/admin/list-stop-cheques?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&blockageStatus=${blockageStatus}`, "GET")
    }
    static listChequeBook = async (page, pageLimit, search, from, to,chequeStatus,deliveryType ) => {
        return await APICall(`/api/Cheque/admin/list-chequebook-request?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&chequeStatus=${chequeStatus}&deliveryType=${deliveryType}`, "GET")
    }
    static exportChequeRequest = async ( search, from, to,chequeStatus,deliveryType) => {
        return await APICall(`/api/Cheque/admin/export-chequebook-request?search=${search}&from=${from}&to=${to}&chequeStatus=${chequeStatus}&deliveryType=${deliveryType}`, "GET")
    }
    static exportStopCheque = async ( search, from, to,blockageStatus) => {
        return await APICall (`/api/Cheque/admin/export-stopcheques?search=${search}&from=${from}&to=${to}&blockageStatus=${blockageStatus}`, "GET")
    }
    static exportConfirmCheque = async (search, from, to) => {
        return await APICall(`/api/Cheque/admin/export-confirmcheques?search=${search}&from=${from}&to=${to}`, "GET")
    }
    static actionStopCheque = async (payload) => {
        return await APICall("/api/Cheque/admin/primary-action-stop-cheque","POST", payload);
    }
    static actionSecStopCheques = async (payload) => {
        return await APICall("/api/Cheque/admin/secondary-action-stop-cheque", "POST", payload);
    }
    static actionChequeRequest = async (payload) => {
        return await APICall("/api/Cheque/admin/action-cheque-request","POST", payload);
    }
    static actionSecChequeRequest = async (payload) => {
        return await APICall ("/api/Cheque/admin/secondary-action-cheque-request", "POST", payload)
    }
    static actionConfirmedCheques = async (payload) => {
        return await APICall("/api/Cheque/admin/primary-action-confirm-cheque", "POST", payload);
    }   
    static actionSecConfirmedCheque = async (payload) => {
        return await APICall("/api/Cheque/admin/secondary-action-confirm-cheque", "POST", payload)
    }
    static summary = async () => {
        return await APICall("/api/Cheque/admin/cheques-summary","GET")
    }
    static listDraft = async (page, pageLimit,search, from, to,draftStatus) => {
        return await APICall(`/api/Draft/admin/list-draft-request?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&draftStatus=${draftStatus}`, "GET")
    }
    static exportDraft = async (search, from, to,draftStatus) => {
        return await APICall(`/api/Draft/admin/export-draft-request?search=${search}&from=${from}&to=${to}&draftStatus=${draftStatus}`,"GET")
    }
    static actionDraft = async (payload) => {
        return await APICall("/api/Draft/admin/primary-action-draft-request", "POST", payload)
    }
    static actionSecDraft = async (payload) => {
        return await APICall ("/api/Draft/admin/secondary-action-draft-request","POST", payload);
    }
}